<div class="store" [class.total]="isTotal" [class.strap]="strapView">
  <div class="title">
    {{text}}
    @if(strapView){
    <div class="box free" [class.placeholder]="placeholder">
      <span class="label">{{"Free"|translate}}</span>
      <span class="count">{{counters.free}}</span>
    </div>
    }
    @if(!isTotal){
    <button class="btn" (click)="handleClick.emit()" [disabled]="placeholder">
      <i class="bi bi-chevron-right"></i>
    </button>
    }
  </div>
  @if(!strapView){
  <div class="stock" [class.placeholder]="placeholder">
    <div class="box free">
      <span class="label">{{"free"|translate}}</span>
      <span class="count">{{counters.free}}</span>
    </div>
    <div class="box">
      <span class="label">{{"reservation"|translate}}</span>
      <span class="count">{{counters.reservation}}</span>
    </div>
    <div class="box">
      <span class="label">{{"CONSIGNMENT"|translate}}</span>
      <span class="count">{{counters.consignmentIn}}</span>
    </div>
    <div class="box">
      <span class="label">{{"In transit"|translate}}</span>
      <span class="count">{{counters.inTransit}}</span>
    </div>
  </div>
  }
</div>
